export default __webpack_public_path__ + "static/media/kiara1.26ba40d7.jpg";